var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    _vm._g({ staticClass: "down-arrow", attrs: { href: "#" } }, _vm.$listeners),
    [
      _c("div", { staticClass: "arrow arrow-1" }),
      _c("div", { staticClass: "arrow arrow-3" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }